import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";

import {SmartOfferBundleNoviceBattlePassDayQuest} from "@/modules/redactor/models/smart-offer/bundle-novice-battle-pass/SmartOfferBundleNoviceBattlePassDayQuest";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";

export class SmartOfferBundleNoviceBattlePassDay extends BaseObject {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(SmartOfferBundleNoviceBattlePassDay, v) : SKIP;
            },
            (v) => {
                return deserialize(SmartOfferBundleNoviceBattlePassDay, v);
            }
        );
    }

    constructor() {

        super();
        this._key = "";
        this._name = "";
        this._latency = 0; // delay before start quests
        this._quests = null;
    }

    get quests() {
        return this._quests;
    }
    set quests(value) {
        this._quests = value;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get latency() {
        return this._latency;
    }
    set latency(value) {
        this._latency = value;
    }

    valid() {
        return !this.empty();
    }

    empty() {
        if (!this.quests || this.quests.length == 0) {
            return true;
        }
        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleNoviceBattlePassDay());
        } else if (target instanceof SmartOfferBundleNoviceBattlePassDay) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleNoviceBattlePassDay, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _latency: alias("latency", Schema.primitive()),
    _quests: alias("quests", list(SmartOfferBundleNoviceBattlePassDayQuest.schema())),
});
